<template>
  <div>
    <section class="flex flex-col w-full">
      <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
        {{ trans.get('dealers.dealers-list') }}
      </h1>
      <div class="flex w-full p-4 justify-end">
        <open-modal modal="dealers-import" class="mr-2">
          {{ trans.get('dealers.excel-import') }}
        </open-modal>
        <open-modal modal="add-dealer">
          {{ trans.get('dealers.add-dealer') }}
        </open-modal>
      </div>
    </section>

    <section class="w-3/4 table mx-auto rounded border shadow-lg">
      <div class="th tr">
        <div class="td">
          {{ trans.get('dealers.company_label') }}
        </div>
        <div class="td">
          {{ trans.get('dealers.visible') }}
        </div>
      </div>
      <section>
        <div class="row"
             v-for="dealer in dealers"
             :key="dealer.id"
             is="DealerRow"
             :dealer="dealer"
        >

        </div>
      </section>
    </section>


    <modal name="add-dealer" height="auto" transition="slide" :clickToClose="false">
      <div class="flex flex-col">

        <div class="w-full flex justify-between items-center py-3 px-1 bg-aitems-700 text-gray-100 mb-6">
          <div class="font-bold tracking-wide p-2 pl-6 uppercase">{{ trans.get('dealers.add-dealer-header') }}</div>
          <div class="font-bold p-2 cursor-pointer"
               @click="$modal.hide('add-dealer')">
            <i class="fas fa-times-circle"></i>
          </div>
        </div>

        <dealer-creator @dealer-has-been-created="onDealerCreated"></dealer-creator>

      </div>
    </modal>

    <modal name="dealers-import" height="auto" transition="slide" :clickToClose="false">
      <div class="flex flex-col">

        <div class="w-full flex justify-between items-center py-3 px-1 bg-aitems-700 text-gray-100 mb-6">
          <div class="font-bold tracking-wide p-2 pl-6 uppercase">{{ trans.get('dealers.dealers-importer-header') }}</div>
          <div class="font-bold p-2 cursor-pointer"
               @click="$modal.hide('dealers-import')">
            <i class="fas fa-times-circle"></i>
          </div>
        </div>

        <dealers-importer @dealers-has-imported="onDealersImported"></dealers-importer>

      </div>
    </modal>

  </div>
</template>

<script>

import openModal from '../buttons/openModal';
import DealerCreator from './DealerCreator';
import DealersImporter from "./DealersImporter";
import DealerRow from "./DealerRow";

export default {

  data() {
    return {
      dealers: []
    }
  },

  components: {
    openModal,
    DealerCreator,
    DealersImporter,
    DealerRow
  },

  created() {
    axios.get('/warranty/dealers')
      .then(({data}) => {
        this.dealers = data
      })
  },

  methods: {
    onDealerCreated() {
      console.log('Hai creato un dealer');
    },

    onDealersImported() {
      console.log('Hai caricato tanti Dealer');
    }
  }

}
</script>

<style scoped>

</style>